import * as React from "react";
import useCursorTracking from "./use-cursors";
import OtherCursors from "./other-cursors";
import Chat from "./Chat";

const ENABLE_CHAT = true;

export default function Cursors() {
  const [isChatEnabled, setIsChatEnabled] = React.useState(ENABLE_CHAT);
  const [isQuietMode, setIsQuietMode] = React.useState(false);
  const [manualDayMode, setManualDayMode] = React.useState<boolean | null>(null);
  useCursorTracking("document");

  React.useEffect(() => {
    const checkNightMode = () => {
      if (manualDayMode !== null) {
        setIsChatEnabled(manualDayMode);
        console.log("Manual mode set:", { manualDayMode, isChatEnabled: manualDayMode });
        return;
      }
      
      const currentHour = new Date().getHours();
      const isNightTime = currentHour >= 22 || currentHour < 6;
      setIsChatEnabled(!isNightTime);
      console.log("Time-based mode:", { currentHour, isNightTime, isChatEnabled: !isNightTime });
    };

    const handleModeChange = () => {
      const dayElement = document.getElementById('day');
      const isDayMode = dayElement?.style.display !== 'none';
      setManualDayMode(isDayMode);
      setIsChatEnabled(isDayMode);
      console.log("Mode change event:", { isDayMode, isChatEnabled: isDayMode });
    };

    checkNightMode();
    handleModeChange();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && 
            (mutation.target instanceof HTMLElement && 
             (mutation.target.id === 'day' || mutation.target.id === 'night'))) {
          handleModeChange();
        }
      });
    });
    
    const dayElement = document.getElementById('day');
    const nightElement = document.getElementById('night');
    if (dayElement) observer.observe(dayElement, { attributes: true });
    if (nightElement) observer.observe(nightElement, { attributes: true });

    const interval = setInterval(checkNightMode, 60000);

    return () => {
      clearInterval(interval);
      observer.disconnect();
    };
  }, [manualDayMode]);

  const toggleQuietMode = () => {
    setIsQuietMode(prev => !prev);
  };

  React.useEffect(() => {
    console.log("isChatEnabled changed:", isChatEnabled);
  }, [isChatEnabled]);

  return (
    <>
      {!isQuietMode && <OtherCursors showChat={isChatEnabled} />}
      <Chat isQuietMode={isQuietMode} toggleQuietMode={toggleQuietMode} isChatEnabled={isChatEnabled} />
    </>
  );
}
